import { render, staticRenderFns } from "./koshaAccident.vue?vue&type=template&id=33e7d661"
import script from "./koshaAccident.vue?vue&type=script&lang=js"
export * from "./koshaAccident.vue?vue&type=script&lang=js"
import style0 from "./koshaAccident.vue?vue&type=style&index=0&id=33e7d661&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33e7d661')) {
      api.createRecord('33e7d661', component.options)
    } else {
      api.reload('33e7d661', component.options)
    }
    module.hot.accept("./koshaAccident.vue?vue&type=template&id=33e7d661", function () {
      api.rerender('33e7d661', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/acc/koshaAccident.vue"
export default component.exports